module.exports = __webpack_public_path__ + "img/drawer.70048678.png";